import React from 'react';
import styled, { css } from 'styled-components';
import propTypes from 'prop-types';
import { BrightGray, PrimaryDark } from '../../../../../../../styling/theme';
import breakpoints from '../../../../../../../styling/breakpointsMinWidth';

const RightToolbarWrapper = styled.ul`
  position: fixed;
  right: 0;
  top: 0;
  grid-column: 9/-1;
  list-style: none;
  align-self: center;
  justify-self: right;
  margin: 0;
  padding: 0;
  display: none;
  flex-direction: row;
  z-index: 6;
  transition: transform 0.3s ease-out;
  transform: ${(props) => (props.open ? 'translateX(0)' : 'translateX(100%)')};
  background-color: ${({ isOutsideLogin }) =>
    isOutsideLogin ? 'white' : BrightGray};
  padding: ${({ isOutsideLogin }) => (isOutsideLogin ? '0' : '20px')};

  ${(props) => {
    const { pathname, user } = props;
    if (!pathname.includes('/documents/')) {
      return css`
        grid-column: ${() => (user ? '8 /span 4' : '6 / -2')};

        li.profileIcon {
          position: relative;
          .drop-down,
          .profile {
            left: auto;
            right: calc(100% - 80px);
            padding: 0.5rem;
            width: 200px;

            background-color: #fff;
            border-radius: 0.4rem;
            box-shadow: 0 4px 10px 1px rgba(41, 49, 89, 0.2);
            z-index: 3;

            li {
              font-size: 16px;
              color: #333d47;
              text-align: left;
              border-bottom: 1px solid;

              &:hover {
                background-color: lightgray;
                color: ${PrimaryDark};
                font-weight: 400;
              }
            }
          }
        }
        @media ${breakpoints.tabletSm} {
          display: grid;
          grid-template-rows: repeat(auto-fill, 72px);
          height: 100vh;
          width: 240px;
          background: white;
          margin-right: 0;

          li: {
            text-align: left;

            &:hover {
              background-color: lightgray;
              color: ${PrimaryDark};
              font-weight: 600;
            }
          }
        }
      `;
    }
    return null;
  }}

  @media ${breakpoints.mobileSm} {
    width: 70%;
    display: flex;
    flex-direction: column;
    height: 100vh;
    margin-right: 0;

    li {
      text-align: left;

      &:hover {
        color: ${PrimaryDark};
        font-weight: 600;
      }
    }
  }

  @media ${breakpoints.mobileMd} {
    width: 70%;
    display: flex;
    flex-direction: column;
    height: 100vh;
    margin-right: 0;

    li {
      text-align: left;

      &:hover {
        color: ${PrimaryDark};
        font-weight: 600;
      }
    }
  }

  @media ${breakpoints.mobileLg} {
    width: 60%;
    display: flex;
    flex-direction: column;
    height: 100vh;
    margin-right: 0;

    li {
      text-align: left;

      &:hover {
        color: ${PrimaryDark};
        font-weight: 600;
      }
    }
  }

  @media ${breakpoints.tabletSm} {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 272px;
    margin-right: 0;
    li {
      text-align: left;
      &:hover {
        color: ${PrimaryDark};
        font-weight: 600;
      }
    }
  }

  @media screen and (min-width: 1024px) {
    display: none;
    flex-direction: column;
    height: 100vh;
    width: 33%;
    margin-right: 0;

    li {
      text-align: left;

      &:hover {
        color: ${PrimaryDark};
        font-weight: 600;
      }
    }
  }

  @media screen and (max-width: 320px) {
    width: 72%;
    display: flex;
    flex-direction: column;
    height: 100vh;
    margin-right: 0;

    li {
      text-align: left;

      &:hover {
        color: ${PrimaryDark};
        font-weight: 600;
      }
    }
  }
`;

const RightToolbar = (props) => {
  const { children, pathname, user, open, isOutsideLogin } = props;
  return (
    <RightToolbarWrapper
      pathname={pathname}
      user={user}
      open={open}
      isOutsideLogin={isOutsideLogin}
    >
      {children}
    </RightToolbarWrapper>
  );
};

RightToolbar.propTypes = {
  children: propTypes.node.isRequired,
  pathname: propTypes.string.isRequired,
  user: propTypes.objectOf(propTypes.object),
  open: propTypes.bool.isRequired,
};

RightToolbar.defaultProps = {
  user: null,
};

export default RightToolbar;
